import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: { marginTop: "20px", position: "relative" },
  enablePermission: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  enablePermissionText: {
    fontSize: "20px",
    fontWeight: 600,
  },
  grayText: {
    color: theme.palette.text.tertiary,
  },
}));
export default useStyles;
